<span>
  <span ng-show="informacaoCultivar.loading">
    <i class="fa fa-spinner fa-spin"></i>
  </span>
  <dl ng-hide="informacaoCultivar.loading">
    <dt>Data de emergência: </dt>
    <dd>{{(informacaoCultivar.dados.data_emergencia | date:'dd/MM/yy') || 'n/a'}}</dd>

    <dt>Data estimada de colheita: </dt>
    <dd>{{(informacaoCultivar.dados.data_estimada_colheita | date:'dd/MM/yy') || 'n/a'}}</dd>
  </dl>
</span>
